module.exports = __webpack_public_path__ + "5b714fec2b8a0611e3288516c265e982.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/pandemiebedingt-03.svg
// module id = 965
// module chunks = 0